import { Component, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LLMActionsInjectorService } from '../../services/llm-actions-injector.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'secondary-masthead, app-secondary-masthead',
    templateUrl: './secondary-masthead.component.html',
    styleUrls: ['./secondary-masthead.component.scss'],
    standalone: false
})
export class SecondaryMastheadComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private llmInjectorService: LLMActionsInjectorService,
    private route: ActivatedRoute
  ) {}


  ngAfterViewInit(): void {
    this.llmInjectorService.setupAutoInjection('secondary-masthead', this.destroy$, this.route);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
